import React from 'react';
import { toUSD } from "../../util/currency-formatter";
import './breakdown.scss';

/**
 * Component to render the grand total costs row.
 *
 * @param {Object} props - Component props.
 * @param {number|string} props.totalCost - Grand total cost value.
 * @returns {JSX.Element} Rendered total costs row.
 */
const TotalCostsRow = ({ totalCost }) => {
  return (
    <div className="breakdown-container">
      <div className="mt-3 border d-flex justify-content-between align-items-center p-3 grand-total">
        <h5 className="mb-0 fw-bold">Grand Total</h5>
        <h5 className="mb-0 fw-bold">{toUSD(totalCost)}</h5>
      </div>
    </div>
  );
};

export default TotalCostsRow; 